
import { useState } from 'react';
import { verifySuperAdminLicense, getSuperAdminInstanceLimits } from '@/utils/licenseService';

export const useLicenseVerification = () => {
  const [licenseInfo, setLicenseInfo] = useState<{
    isValid: boolean;
    message?: string;
    maxInstances?: number;
    usedInstances?: number;
    remainingInstances?: number;
    plan?: string;
  } | null>(null);
  const [isVerifyingLicense, setIsVerifyingLicense] = useState(false);

  const verifyLicense = async (superAdminId: string) => {
    if (!superAdminId) {
      console.error('No superAdminId provided for license verification');
      return;
    }
    
    setIsVerifyingLicense(true);
    try {
      // Verify license status
      const verificationResult = await verifySuperAdminLicense(superAdminId);
      
      if (verificationResult.isValid) {
        // Get instance limits if license is valid
        const limits = await getSuperAdminInstanceLimits(superAdminId);
        
        setLicenseInfo({
          isValid: true,
          maxInstances: limits.maxInstances,
          usedInstances: limits.usedInstances,
          remainingInstances: limits.remainingInstances,
          plan: limits.plan
        });
      } else {
        setLicenseInfo({
          isValid: false,
          message: verificationResult.message
        });
      }
    } catch (error) {
      console.error('Error verifying license:', error);
      setLicenseInfo({
        isValid: false,
        message: 'Failed to verify license'
      });
    } finally {
      setIsVerifyingLicense(false);
    }
  };

  return {
    licenseInfo,
    isVerifyingLicense,
    verifyLicense
  };
};
